import { Item } from '../../core';
import { ViewCategory } from '../model/view-category.model';
import { ViewItem } from '../model/view-item.model';

export function itemTransformer(
    items: Item[],
    categories: ViewCategory[],
): ViewItem[] {
    return (
        items?.map<ViewItem>((e) => {
            const value = e.timestamp as any as string;
            const cat = categories.find((c) => c.categoryId === e.categoryId);
            return {
                ...e,
                timestamp:
                    value == null
                        ? new Date()
                        : new Date(
                              value.trim().toLowerCase().endsWith('z')
                                  ? value
                                  : `${value}Z`,
                          ),
                icon: cat?.icon,
                colour: cat?.colour,
            };
        }) ?? []
    );
}
